import type { ShopWithdrawalRequest } from '../types';

/** Human-readable reason a shop payout is waiting for approval. */
export function getShopWithdrawalReviewReason(w: ShopWithdrawalRequest): string | null {
  return (
    w.flaggedInfo?.triggeringRule?.description
    || w.autoApproveSkipReason
    || w.flaggedInfo?.reasons?.[0]?.description
    || null
  );
}
